import { Component, OnInit, ViewChild, ElementRef, Inject } from '@angular/core';
import { FormGroup, AbstractControl, FormBuilder, Validators } from '@angular/forms';
import { statusObj } from 'src/app/dummy/status';
import { MatDialogRef, MAT_DIALOG_DATA, MatSnackBar } from '@angular/material';
import { DataService } from 'src/app/services/data.service';
import { IDegree } from 'src/app/interfaces/country';
import { pageKey, toNumber } from 'src/app/services/mapping.service';
import { List } from 'src/app/stores/administrator/list.store';
import { AuthService } from 'src/app/auth/auth.service';
import { AuthStore } from 'src/app/stores/auth/auth.store';

@Component({
  selector: 'app-add-degree',
  templateUrl: './add-degree.component.html',
  styleUrls: ['./add-degree.component.scss']
})
export class AddDegreeComponent implements OnInit {
  @ViewChild("focus", { static: false }) inputRef: ElementRef;

  form: FormGroup;
  duration: AbstractControl;
  name: AbstractControl;
  degree: AbstractControl
  description: AbstractControl;
  order: AbstractControl;
  level: AbstractControl

  LEVEL_LIST: Array<any> = [];

  constructor(
    public dialogRef: MatDialogRef<AddDegreeComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    public store: List,
    public ds: DataService,
        public auth: AuthStore,
    private snackBar: MatSnackBar,
  ) { }

  async ngOnInit() {
    this.form = this.fb.group({
      name: [null, Validators.required],
      duration: [null, Validators.required],
      description: [null],
      order: [null, Validators.required],
      degree: [null, Validators.required],
      level: [null, Validators.required]
    });
    this.duration = this.form.controls["duration"]
    this.name = this.form.controls['name'];
    this.description = this.form.controls['description'];
    this.order = this.form.controls["order"]
    this.degree = this.form.controls["degree"]
    this.level = this.form.controls["level"]

    this.LEVEL_LIST = await this.store.fetchList(this.ds.levelRef(ref => ref.orderBy('order')))
    this.form.patchValue({
      level: this.LEVEL_LIST.length > 0 ? this.LEVEL_LIST[0] : null
    })
  }

  compareObjects(o1: any, o2: any): boolean {
    return o1 && o2 ? o1.key === o2.key : o1 === o2;
  }


  create(f: any, isNew: boolean) {
    if (this.form.valid) {
      this.form.disable()
      const { shiftType, duration, order, name, description, degree, level } = f;
      const item: IDegree = {
        key: this.ds.createId(),
        page_key: pageKey(),
        created_date: new Date(),
        created_by: this.ds.collection('users').doc(`${this.auth.user.uid}`).ref,
        isDeleted: false,
        name: name,
        description: description,
        status: statusObj.active,
        order: toNumber(order),
        duration: duration,
        degree,
        levelKey: level.key,
        levelRef: this.ds.levelRef().doc(`${level.key}`).ref,
      }
      this.store.save(this.ds.degreeRef(), item, (success, res) => {
        if (success) {
          if (!isNew) {
            this.dialogRef.close();
          }
          this.snackBar.open('Degree has been created.', 'done', { duration: 3000 });
          this.form.reset();
          this.form.enable();
          this.form.patchValue({
            shiftType,level
          })
          this.inputRef.nativeElement.focus();
        } else {
          alert(res);
        }
      })
    }
  }
}
